import { GlobalStyles } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import { Dayjs } from 'dayjs';

// Custom day component with weekend colors
export const CustomDay = (props: PickersDayProps<Dayjs>) => {
  const { day, ...other } = props;
  const dayOfWeek = day.day(); // 0 = Sunday, 6 = Saturday

  return (
    <PickersDay
      {...other}
      day={day}
      sx={{
        // Weekday (Monday-Friday) - Keep primary.main color for selected state
        ...(dayOfWeek >= 1 &&
          dayOfWeek <= 5 && {
            '&.Mui-selected': {
              backgroundColor: '#0047BA !important',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#0047BA !important',
              },
            },
          }),
        ...(dayOfWeek === 0 && {
          // Sunday - Red
          color: '#d32f2f',
          '&.Mui-selected': {
            backgroundColor: '#d32f2f !important',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#b71c1c !important',
            },
          },
        }),
        ...(dayOfWeek === 6 && {
          // Saturday - Blue
          color: '#1976d2',
          '&.Mui-selected': {
            backgroundColor: '#1976d2 !important',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#1565c0 !important',
            },
          },
        }),
      }}
    />
  );
};

// Sx styles for calendar header (fontWeight only, colors handled by GlobalStyles)
export const customCalendarHeaderSx = {
  '& .MuiPickersCalendarHeader-label': {
    fontWeight: 500,
  },
};

// Global styles component for calendar header weekend colors
// This is needed because calendar renders in a portal and sx in slotProps may not work
export const CustomCalendarHeaderStyles = () => (
  <GlobalStyles
    styles={{
      '.MuiPickersCalendarHeader-weekDayLabel:nth-of-type(1), .MuiDayCalendar-weekDayLabel:nth-of-type(1), .MuiPickersCalendarHeader-dayLabel:nth-of-type(1)':
        {
          // Sunday - Red
          color: '#d32f2f !important',
        },
      '.MuiPickersCalendarHeader-weekDayLabel:nth-of-type(7), .MuiDayCalendar-weekDayLabel:nth-of-type(7), .MuiPickersCalendarHeader-dayLabel:nth-of-type(7)':
        {
          // Saturday - Blue
          color: '#1976d2 !important',
        },
      // Month calendar view - auto height to fit all months
      '.MuiMonthCalendar-root': {
        width: '100%',
        height: 'auto !important',
        maxWidth: '320px',
        margin: '0 auto',
        paddingBottom: '0 !important',
      },
      '.MuiPickersMonth-root': {
        flexBasis: '33.33%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '7px 0',
      },
      '.MuiPickersMonth-monthButton': {
        fontSize: '0.875rem',
        fontWeight: 400,
        margin: 0,
      },
      // Remove extra padding from month calendar container
      '.MuiPickersCalendarHeader-root + .MuiMonthCalendar-root': {
        marginTop: '15px',
      },
    }}
  />
);
